import Link from 'next/link'
import { useAppContext } from '../../../context/siteMapContext';
import { IWebMenu } from '../../../interfaces/webMenu'
import { urlObjectFactoryForWebmenus } from '../../../utils/webmenus'

interface ISubMenuListItemProps {
  webmenu: IWebMenu
  fontColor: string;
}

interface ISubMenuListProps {
  subMenus: IWebMenu[]
  fontColor: string;
}

const SubMenuListItem: React.FC<ISubMenuListItemProps> = ({ webmenu, fontColor }) => {
  const { highContrastOn } = useAppContext();
  const { urlObject, asPath } = urlObjectFactoryForWebmenus(webmenu)
  return (
    <li className={`text-card-list 2xl:text-card-list-2xl`} style={{ color: highContrastOn ? '#000' : (fontColor || '#fff') }}>
      <Link href={webmenu.link ?? urlObject} as={webmenu.link ? undefined : asPath} >
        <a className='font-montserrat font-semibold' style={{ color: highContrastOn ? '#000 !important' : (fontColor || '#fff') }} target={webmenu.openNewTab ? '_blank' : '_self'}>{webmenu.name_HU}</a>
      </Link>
    </li>
  )
}

const SubMenuList: React.FC<ISubMenuListProps> = ({ subMenus, fontColor }) => {
  return (
    <div className='flex items-center h-full w-full'>
      <ul className='list-disc'>
        {subMenus.map((webmenu) => {
          return <div key={webmenu.id}>{webmenu.visible && <SubMenuListItem key={webmenu.id} webmenu={webmenu} fontColor={fontColor} />}</div>
        })}
      </ul>
    </div>
  )
}

export default SubMenuList
